import BaseConst from './BaseConst';

export default class BaseTranslations {

  protected lang: string;
  protected data: {[key:string]: {[key:string]: any}};

  constructor(lang: string) {
    this.data = {
      ru: {},
      uk: {}
    };
    this.lang = this.checkLang(lang);
  }

  /**
   *
   * @param lang
   * @returns {string}
   */
  protected checkLang(lang: string): string {
    let supportedLanguages = Object.keys(this.data);
    return supportedLanguages.indexOf(lang) !== -1 ? lang : BaseConst.LANG_DEFAULT;
  };

  /**
   * "lang" из параметров имеет более высокий приоритет, чем одноимённое поле класса
   *
   * @param {string} messageId
   * @param {string} lang
   * @returns {string}
   */
  public getText(messageId: string, lang: string = ''): string {
    let language = lang === '' ? this.lang : this.checkLang(lang);
    let message = '';
    if (typeof this.data[language][messageId] !== 'undefined') {
      message = this.data[language][messageId];
    }
    return message;
  }
}
